'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var types = {
  TRACK_EVENT: 'PICO_ANALYTICS/TRACK_EVENT',
  IDENTIFY_USER: 'PICO_ANALYTICS/IDENTIFY_USER',
  PAGE_VISIT: 'PICO_ANALYTICS/PAGE_VISIT',
  RESET: 'PICO_ANALYTICS/RESET',
  SET_GUEST: 'PICO_ANALYTICS/SET_GUEST',
  SET_USER: 'PICO_ANALYTICS/SET_USER'
};
var creators = {
  trackEvent: function trackEvent(payload) {
    return {
      type: types.TRACK_EVENT,
      payload: payload
    };
  },
  identifyUser: function identifyUser(payload) {
    return {
      type: types.IDENTIFY_USER,
      payload: payload
    };
  },
  pageVisit: function pageVisit(payload) {
    return {
      type: types.PAGE_VISIT,
      payload: payload
    };
  },
  reset: function reset() {
    return {
      type: types.RESET
    };
  },
  setGuest: function setGuest(payload) {
    return {
      type: types.SET_GUEST,
      payload: payload
    };
  },
  setUser: function setUser(payload) {
    return {
      type: types.SET_USER,
      payload: payload
    };
  }
};

exports.creators = creators;
exports.types = types;
//# sourceMappingURL=actions.js.map
